"use client";

import styled from "styled-components";
import { Button, Menu } from "@lmn/design-system";

export const Container = styled.div`
  position: relative;
`;

export const Pill = styled.button<{
  $isOpen: boolean;
  $isFilterActive?: boolean;
}>`
  align-items: center;
  font-size: 0.875rem;
  background: ${({ theme }) =>
    theme.kallisto.color.background.static.backgroundPage};
  border-radius: 100px;
  color: ${({ theme }) => theme.kallisto.color.text.static.textPrimary};
  cursor: pointer;
  display: inline-flex;
  height: 2.25rem;
  line-height: normal;
  padding: 0 1rem;
  white-space: nowrap;
  border: 1px solid
    ${({ theme }) => theme.kallisto.color.border.static.borderNeutral};
  gap: 0.5rem;

  &:hover {
    border-color: ${({ theme }) =>
      theme.kallisto.color.border.interactive.borderPrimaryDefault};
    color: ${({ theme }) =>
      theme.kallisto.color.text.interactive.textPrimaryDefault};
    background: ${({ theme }) =>
      theme.kallisto.color.background.interactive.backgroundPrimarySelected};
  }

  svg {
    transition: transform 0.3s ease-in-out;
  }

  &:focus-visible {
    outline: 2px solid
      ${({ theme }) =>
        theme.kallisto.color.border.interactive.borderPrimaryDefault};
    outline-offset: 2px;
  }

  ${({ $isFilterActive, theme }) =>
    $isFilterActive &&
    `
    border-color: ${theme.kallisto.color.border.interactive.borderPrimaryDefault};
    background: ${theme.kallisto.color.background.interactive.backgroundPrimarySelected};
  `}

  ${({ $isOpen, theme }) =>
    $isOpen &&
    `
    border-color: ${theme.kallisto.color.border.interactive.borderPrimaryDefault};
    color: ${theme.kallisto.color.text.interactive.textPrimaryDefault};

    svg {
      transform: rotate(180deg);
    }
  `}
`;

export const ArrowWrapper = styled.span`
  display: flex;
  align-items: center;
`;

export const CloseButton = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  padding: 0;
  background: ${({ theme }) =>
    theme.kallisto.color.background.interactive.backgroundPrimaryDefault};
  color: ${({ theme }) => theme.kallisto.color.icon.static.iconOnDark};

  &:hover {
    background: ${({ theme }) =>
      theme.kallisto.color.background.interactive.backgroundPrimaryHover};
  }


  "&:active": {
    background: ${({ theme }) =>
      theme.kallisto.color.background.interactive.backgroundPrimaryPressed}
    
  },
    "&:focus": {
    background: ${({ theme }) =>
      theme.kallisto.color.background.interactive.backgroundPrimaryPressed}
  },
  
 
  "&:disabled": {
    cursor: "not-allowed",
      background: ${({ theme }) =>
        theme.kallisto.color.background.static.backgroundDisabled}
  },

    &:focus-visible {
    outline: 2px solid
      ${({ theme }) => theme.kallisto.color.common.white[1000]};
    outline-offset: 0;
    box-shadow: 0 0 0 4px ${({ theme }) =>
      theme.kallisto.color.common.black[1000]};
  }



`;

export const MenuContent = styled.div<{ $scrollable?: boolean }>`
  padding: 1rem;
  min-width: 300px;
  ${({ $scrollable }) =>
    $scrollable &&
    `
    max-height: 300px;
    overflow-y: auto;
  `}
`;

export const ButtonsContainer = styled.div`
  display: flex;
  gap: 0.5rem;
  justify-content: flex-end;
  padding: 0.5rem;
  border-top: 1px solid
    ${({ theme }) => theme.kallisto.color.border.static.borderNeutral};
  margin-top: 0.5rem;
`;

export const CancelButton = styled(Button)`
  && {
    min-width: auto;
  }
`;

export const ConfirmButton = styled(Button)`
  && {
    min-width: auto;
  }
`;

export const StyledMenu = styled(Menu)<{ $disableInternalScroll?: boolean }>`
  ${({ $disableInternalScroll }) =>
    $disableInternalScroll &&
    `
    .MuiPaper-root {
      max-height: none !important;
      overflow: visible !important;
    }
    .MuiList-root {
      overflow: visible !important;
    }
  `}
`;
